export const ECHO_DEVICE_TYPES = ['echo', 'subscriber', 'ES3_28', 'ES4_39'];
export const PIVOT_DEVICE_TYPES = [
  'donor',
  'service',
  'HBF_SERVICE',
  'HORN_WIDE_SERVICE',
  'HORN_NARROW_SERVICE',
  'HBF_DONOR'
];
export const ESX_M6 = ['ESX_M6'];
export const GA2_N257 = ['ga2-n257'];
export const GA2_N258 = ['ga2-n258'];
export const GA2_N260 = ['ga2-n260'];

const LOCKED_ADMIN_STATE = ['lock', 'locked'];
const UNLOCKED_ADMIN_STATE = ['unlocked', 'idle', 'running', 'unknown'];
const ALARM_TYPES = ['critical', 'major', 'minor', 'warning'];

export const FILTER_DEVICE_TYPES = [
  { type: 'Echo 5G', values: ECHO_DEVICE_TYPES },
  {
    type: 'Pivot 5G',
    values: PIVOT_DEVICE_TYPES
  },
  {
    type: 'ESX_M6',
    values: ESX_M6
  },
  {
    type: 'GA2-N257',
    values: GA2_N257
  },
  {
    type: 'GA2-N258',
    values: GA2_N258
  },
  {
    type: 'GA2-N260',
    values: GA2_N260
  }
];

export const getTrimmedString = (text, maxLength) => {
  if (text.length <= maxLength) return text;

  return text.slice(0, maxLength - 3) + '...';
};
/**
 * Parses saved filter set and translates to raw filters
 * @param {object} filterSet
 * @returns a parsed filter set that contains raw filters data for search
 */
export const getParsedFilterSet = (filterSet) => {
  if (!filterSet) return {};

  const activeFilters = {};

  for (const [key, value] of Object.entries(filterSet)) {
    if (!value) continue;
    switch (key) {
      case 'connectionStatus':
        activeFilters.connectionState = [];
        if (value.includes('Online')) {
          activeFilters.connectionState.push('Connected');
        }
        if (value.includes('Offline')) {
          activeFilters.connectionState.push('Disconnected');
        }
        break;
      case 'adminState':
        activeFilters['properties.reported.adminState'] = [];
        if (value.includes('Locked')) {
          activeFilters['properties.reported.adminState'].push(...LOCKED_ADMIN_STATE);
        }
        if (value.includes('Unlocked')) {
          activeFilters['properties.reported.adminState'].push(...UNLOCKED_ADMIN_STATE);
        }
        break;
      case 'operationalState':
        activeFilters['properties.reported.operationState'] = [];
        if (value.includes('Enabled')) {
          activeFilters['properties.reported.operationState'].push('enabled');
        }
        if (value.includes('Disabled')) {
          activeFilters['properties.reported.operationState'].push('disabled');
        }
        break;
      case 'deviceType':
        activeFilters['properties.reported.productType'] = [];

        FILTER_DEVICE_TYPES.forEach((dt) => {
          if (value.includes(dt.type)) {
            activeFilters['properties.reported.productType'].push(...dt.values);
          }
        });
        break;
      case 'provisionedOn':
        activeFilters['provisionTime'] = {
          from: value[0],
          to: value[1]
        };

        break;
      case 'alarms':
        for (let alarm of value) {
          activeFilters['tags.fm-alarms.' + alarm.toLowerCase()] = true;
        }
        break;
      default:
        break;
    }
  }

  return activeFilters;
};

/**
 * Translates raw filter to filter set to save
 * @param {object} rawFilter
 */
export const getFilterSetToSave = (rawFilter, allDevicesTab) => {
  let filterSet = {};

  if (rawFilter.connectionState) {
    filterSet.connectionStatus = [];
    if (rawFilter.connectionState.includes('Connected')) {
      filterSet.connectionStatus.push('Online');
    }
    if (rawFilter.connectionState.includes('Disconnected')) {
      filterSet.connectionStatus.push('Offline');
    }
  }
  if (rawFilter['properties.reported.adminState']) {
    filterSet.adminState = [];
    if (rawFilter['properties.reported.adminState'].includes(...LOCKED_ADMIN_STATE)) {
      filterSet.adminState.push('Locked');
    }
    if (rawFilter['properties.reported.adminState'].includes(...UNLOCKED_ADMIN_STATE)) {
      filterSet.adminState.push('Unlocked');
    }
  }
  if (rawFilter['properties.reported.operationState']) {
    filterSet.operationalState = [];
    if (rawFilter['properties.reported.operationState'].includes('enabled')) {
      filterSet.operationalState.push('Enabled');
    }
    if (rawFilter['properties.reported.operationState'].includes('disabled')) {
      filterSet.operationalState.push('Disabled');
    }
  }
  if (allDevicesTab && rawFilter['properties.reported.productType']) {
    const productType = rawFilter['properties.reported.productType'];
    filterSet.deviceType = [];

    FILTER_DEVICE_TYPES.forEach((dt) => {
      if (productType.includes(...dt.values)) {
        filterSet.deviceType.push(dt.type);
      }
    });
  }
  if (rawFilter['provisionTime']) {
    const { from, to } = rawFilter['provisionTime'];
    filterSet.provisionedOn = [from, to];
  }
  ALARM_TYPES.forEach((alarm) => {
    if (rawFilter['tags.fm-alarms.' + alarm]) {
      if (!filterSet.alarms) filterSet.alarms = [];
      filterSet.alarms.push(alarm[0].toUpperCase() + alarm.slice(1));
    }
  });

  return filterSet;
};
